import React from "react"
import Icon from '../app_components/Icon'
import { semantic } from '@lexody/design-tokens'

const SUGGESTIONS = (name) => [
  `Hey ${name}! Want to connect and schedule a Lex soon?`,
  `Hi ${name} — want to connect? I'm looking for a new Lex partner.`,
  `Hi ${name}! Let's connect so we can chat and schedule a Lex. Are you free this week?`,
  `Hi ${name}! I'm a serious language learner looking for more connects. Hope to hear from you!`,
  `Hi ${name}! I'm new to Lexody and looking for more connects. When would you be available to Lex?`,
]

class ConnectMsgSuggestions extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      tab: 0,
    }

    this.prevTab = this.prevTab.bind(this)
    this.nextTab = this.nextTab.bind(this)
  }

  suggestions() {
    return SUGGESTIONS(this.props.requestee_name)
  }

  currentSuggestion() {
    return this.suggestions()[this.state.tab]
  }

  prevTab() {
    if (this.state.tab > 0) {
      this.setState({ tab: this.state.tab - 1 })
    }
  }

  nextTab() {
    const lastIndex = this.suggestions().length - 1
    if (this.state.tab < lastIndex) {
      this.setState({ tab: this.state.tab + 1 })
    }
  }

  render() {
    const suggestions = this.suggestions()
    const canGoPrev = this.state.tab > 0
    const canGoNext = this.state.tab < suggestions.length - 1

    return (
      <div className="connectRequestModal__suggestions">
        <div className="connectRequestModal__suggestionsHeader">
          <button
            type="button"
            className="connectRequestModal__suggestionsNav"
            onClick={this.prevTab}
            disabled={!canGoPrev}
            aria-label="Previous suggestion"
          >
            <Icon
              name="arrow-left"
              size={14}
              color={canGoPrev ? '#fff' : 'rgba(255,255,255,0.35)'}
            />
          </button>
          <span className="connectRequestModal__suggestionsLabel">Tap a suggestion</span>
          <button
            type="button"
            className="connectRequestModal__suggestionsNav"
            onClick={this.nextTab}
            disabled={!canGoNext}
            aria-label="Next suggestion"
          >
            <Icon
              name="arrow-right"
              size={14}
              color={canGoNext ? '#fff' : 'rgba(255,255,255,0.35)'}
            />
          </button>
        </div>

        <button
          type="button"
          className="connectRequestModal__suggestion"
          onClick={() => this.props.selectPrompt(this.currentSuggestion())}
        >
          {this.currentSuggestion()}
        </button>

        <div className="connectRequestModal__suggestionsDots" aria-hidden="true">
          {suggestions.map((_, index) => (
            <span
              key={index}
              className={[
                'connectRequestModal__suggestionsDot',
                index === this.state.tab ? 'connectRequestModal__suggestionsDot--active' : '',
              ].filter(Boolean).join(' ')}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default ConnectMsgSuggestions
